// Copyright (c) 2017 Deere & Company

import DealerHierarchyTerritory from '@deere/cps-it.warranty-model-factory/lib/dealer-hierarchy-territory';
import t from 'tcomb';

const FilteredTerritories = t.list(DealerHierarchyTerritory, 'FilteredTerritories');

export const getDefaultState = () => new FilteredTerritories([]);

export default FilteredTerritories;



// WEBPACK FOOTER //
// ./src/tabm/shared/state/filtered-territories.js